import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const ClinicAdminRoute: React.FC = () => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const role = (user.Role || user.role || '').toLowerCase();
  if (role !== 'clinic admin') {
    return <Navigate to="/client/patients" replace />;
  }

  return <Outlet />;
};

export default ClinicAdminRoute;
